import React from "react";
import { MainLayout } from "../../MainLayout";
import { SingaporeSec1Data } from "../../../Data/IndiaSec1Data";
import { Footer } from "../../Footer";
import { IndiaSec4 } from "../India/IndiaSec4/IndiaSec4";
import { IndiaSec1 } from "../India/IndiaSec1/IndiaSec1";
import { IndiaSec2 } from "../India/IndiaSec2/IndiaSec2";
import { IndiaSec3 } from "../India/IndiaSec3/IndiaSec3";

export const Singapore = () => {

    const destinationPackages = [
        {
            mapImg: "/assets/singapore-air.png",
            sliderimg: [
                {
                    id: 1,
                    img: "https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/DMC%20New%20Images/Beautiful_Singapore/Beautiful_Singapore_2.webp",
                    title: "Beautiful Singapore",
                },
                {
                    id: 2,
                    img: "https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/DMC%20New%20Images/Beautiful_Singapore/Beautiful_Singapore_3.webp",
                    title: "Ultimate Singapore",
                },
            ],
            title: "3N/4D Beautiful Singapore",
            days: "3N/4D",
            tags: ["WaterFall", "Temples", "Sightseeing"],
            description:
                "Discover the vibrant city-state of Singapore, where modern architecture meets lush greenery and cultural heritage. This 4-day, 3-night package offers the perfect blend of sightseeing, entertainment, and relaxation.Begin your journey with a panoramic city tour covering iconic landmarks such as Merlion Park, Chinatown, and Marina Bay. Experience the fun and thrill of Sentosa Island, featuring the cable car ride, Madame Tussauds 4-in-1, and the spectacular Wings of Time show. Spend an entire day at Universal Studios Singapore, where world-class rides and attractions bring movie magic to life.",
            img: "/assets/india-ite-char-dham.jpeg",
            slug: "beautifulSingapore",
        },
        {
            title: "3N/4D Singapore Delight",
            days: "3N/4D",
            tags: ["Sightseeing", "Mountain", "Lakes"],
            description:
                "Experience the charm of Singapore, a dazzling city that blends modern sophistication with rich cultural heritage. This 4-day Singapore Delight Package showcases the city’s most iconic attractions — from its futuristic skyline to its tropical landscapes.Enjoy a panoramic city tour, uncover the excitement of Sentosa Island with its world-class attractions, and immerse yourself in the spectacular beauty of Gardens by the Bay. With comfortable stays, daily breakfasts, guided tours, and private transfers, this short yet enriching getaway is perfect for families, couples, and leisure travelers seeking the best of Singapore.",
            img: "https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/DMC%20New%20Images/Singapore%20Delights/Singapore_Delight_2.webp",

            slug: "singaporeDelight",
        },
        {
            title: "4N/5D Amazing Singapore",
            days: "4N/5D",
            tags: ["WildLife", "Boat House", "WaterFall"],
            description:
                "Discover the best of Singapore with this 5-day Amazing Singapore Package, a perfect blend of adventure, culture, and relaxation. Explore the city's iconic landmarks on a half-day city tour, experience the thrilling Night Safari, and spend an unforgettable day at Universal Studios Singapore. Immerse yourself in the magic of Sentosa Island and the futuristic beauty of Gardens by the Bay. With comfortable accommodations, seamless transfers, and exciting excursions, this package is designed to give you the ultimate Singapore holiday experience. ",
            img: "https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/DMC%20New%20Images/Amazing%20Sinapore/Amazing_singapore_2.webp",

            slug: "amazingSingapore",
        },
        {
            title: "4N/5D Ultimate Singapore",
            days: "4N/5D",
            tags: ["Temples", "Monuments", "Sightseeing"],
            description:
                "Discover the vibrant city of Singapore — a dazzling fusion of innovation, nature, and culture. This 5-day Ultimate Singapore Package brings together the city’s most exciting highlights: explore modern landmarks on a city tour, experience the thrills of Universal Studios, unwind at Sentosa Island, and marvel at the breathtaking beauty of Gardens by the Bay. With comfortable stays, daily breakfast, and seamless transfers, this tour is the perfect blend of leisure, entertainment, and exploration. ",
            img: "https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/DMC%20New%20Images/Ultimate%20Singapore/Ultimate_Singapore_2.webp",

            slug: "ultimateSingapore",
        },
    ];

    const topcitydata = [
        {
            id: 1,
            title: "Marina Bay",
            img: "https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/New-DMC/DMC%20Destination/Singapore%20top%20places/Singapore%20top%20places/Marina%20Bay.webp",
            desc: [
                <p>
                    <strong>Why Visit: </strong>A gleaming symbol of modern Singapore,
                    Marina Bay brings together the city’s bold architecture and waterfront
                    elegance. Watch the skyline shimmer at sunset, stroll along the
                    promenade, and witness the city’s futuristic heart come alive.
                </p>,
                <p>
                    <strong>Top Attractions: </strong>Marina Bay Sands, ArtScience Museum,
                    Gardens by the Bay, Helix Bridge, Merlion Park, SkyPark Observation
                    Deck, Spectra Light & Water Show, Esplanade – Theatres on the Bay.
                </p>,
            ],
        },
        {
            id: 2,
            title: "Sentosa Island",
            img: "https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/New-DMC/DMC%20Destination/Singapore%20top%20places/Singapore%20top%20places/Sentosa%20Island.webp",
            desc: [
                <p>
                    <strong>Why Visit: </strong>Singapore’s island of fun and leisure,
                    Sentosa is where adventure and relaxation coexist. Golden beaches,
                    thrilling rides, and oceanfront dining make it a destination that
                    delights every kind of traveler.
                </p>,
                <p>
                    <strong>Top Attractions: </strong>Universal Studios Singapore, S.E.A.
                    Aquarium, Adventure Cove Waterpark, Siloso Beach, Palawan Beach,
                    Tanjong Beach Club, SkyHelix Sentosa, Madame Tussauds Singapore, Fort
                    Siloso, Sentosa Boardwalk.
                </p>,
            ],
        },
        {
            id: 3,
            title: "Chinatown",
            img: "https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/New-DMC/DMC%20Destination/Top%20Places/China%20town%20Singapore.webp",
            desc: [
                <p>
                    <strong>Why Visit: </strong>Every corner of Chinatown tells a story of
                    culture and heritage. Lantern-lit streets, ancient temples, and
                    sizzling hawker stalls create an atmosphere that’s both historic and
                    full of life.
                </p>,
                <p>
                    <strong>Top Attractions: </strong>Buddha Tooth Relic Temple, Sri
                    Mariamman Temple, Pagoda Street, Maxwell Food Centre, Ann Siang Hill,
                    Smith Street Market, Telok Ayer Street, Chinatown Street Market, Thian
                    Hock Keng Temple.
                </p>,
            ],
        },
        {
            id: 4,
            title: "Little India",
            img: "https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/New-DMC/DMC%20Destination/Top%20Places/Littile%20India%20Singapore.webp",
            desc: [
                <p>
                    <strong>Why Visit: </strong>Bursting with color, aroma, and tradition,
                    Little India captures the spirit of diversity. The bustling markets
                    and ornate temples invite travelers to experience Singapore’s cultural
                    richness up close.
                </p>,
                <p>
                    <strong>Top Attractions: </strong>Sri Veeramakaliamman Temple, Tekka
                    Centre, Mustafa Centre, Little India Arcade, House of Tan Teng Niah,
                    Indian Heritage Centre, Serangoon Road, Campbell Lane, Race Course
                    Road.
                </p>,
            ],
        },
        {
            id: 5,
            title: "Clarke Quay",
            img: "https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/New-DMC/DMC%20Destination/Singapore%20top%20places/Singapore%20top%20places/Clarke%20Quay.webp",
            desc: [
                <p>
                    <strong>Why Visit: </strong>By day, a riverside escape; by night, a
                    hub of music, lights, and laughter. Clarke Quay combines dining,
                    entertainment, and the city’s vibrant nightlife in one lively
                    waterfront district.
                </p>,
                <p>
                    <strong>Top Attractions: </strong>Singapore River Cruise, Riverside
                    Point, Clarke Quay Central, Zouk Singapore, The Pump Room, Asian
                    Civilisations Museum, Fort Canning Park, Read Bridge, Boat Quay, G-Max
                    Reverse Bungy.
                </p>,
            ],
        },
        {
            id: 6,
            title: "Orchard Road",
            img: "https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/New-DMC/DMC%20Destination/Singapore%20top%20places/Singapore%20top%20places/Orchard%20Road.webp",
            desc: [
                <p>
                    <strong>Why Visit: </strong>The pulse of Singapore’s fashion and
                    retail scene. Orchard Road is all about luxury, leisure, and
                    lifestyle, making it a must-visit for anyone who loves the buzz of
                    city elegance.
                </p>,
                <p>
                    <strong>Top Attractions: </strong>ION Orchard, Ngee Ann City, Paragon
                    Mall, Orchard Central, Emerald Hill, Plaza Singapura, TANGS, Mandarin
                    Gallery, Wisma Atria, Orchard Gateway.
                </p>,
            ],
        },
        {
            id: 7,
            title: "Singapore Botanic Gardens",
            img: "https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/New-DMC/DMC%20Destination/Singapore%20top%20places/Singapore%20top%20places/Singapore%20Botanic%20Gardens.webp",
            desc: [
                <p>
                    <strong>Why Visit: </strong>A UNESCO World Heritage treasure and a
                    peaceful retreat in the heart of the city. The gardens invite
                    travelers to slow down and admire Singapore’s natural beauty at its
                    finest.
                </p>,
                <p>
                    <strong>Top Attractions: </strong>National Orchid Garden, Swan Lake,
                    Rainforest Trail, Jacob Ballas Children’s Garden, Symphony Lake,
                    Ginger Garden, Bandstand, Eco-Garden, Heritage Trees, Gallop
                    Extension.
                </p>,
            ],
        },
        {
            id: 8,
            title: "Kampong Glam",
            img: "https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/New-DMC/DMC%20Destination/Singapore%20top%20places/Singapore%20top%20places/Kampong%20Glam.webp",
            desc: [
                <p>
                    <strong>Why Visit: </strong>Where old meets new, Kampong Glam reflects
                    the city’s creative soul. Traditional Malay heritage blends with
                    trendy cafes, street art, and boutiques that celebrate modern culture.
                </p>,
                <p>
                    <strong>Top Attractions: </strong>Sultan Mosque, Haji Lane, Arab
                    Street, Malay Heritage Centre, Bussorah Street, Gedung Kuning,
                    Kandahar Street, Aliwal Arts Centre, Textile Centre, Muscat Street.
                </p>,
            ],
        },
        {
            id: 9,
            title: "Singapore Zoo & Jurong Bird Park",
            img: "https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/New-DMC/DMC%20Destination/Singapore%20top%20places/Singapore%20top%20places/Singapore%20Zoo%20&%20Jurong%20Bird%20Park.webp",
            desc: [
                <p>
                    <strong>Why Visit: </strong>Home to some of the world’s most stunning
                    wildlife encounters, Singapore Zoo and Jurong Bird Park redefine the
                    connection between nature and conservation. Perfect for family
                    travelers and wildlife enthusiasts alike.
                </p>,
                <p>
                    <strong>Top Attractions: </strong>Rainforest Kidzworld, Night Safari,
                    River Wonders, Fragile Forest, Treetops Trail, Bird Paradise, Lory
                    Loft, Penguin Cove, Wings of Asia, Waterfall Aviary.
                </p>,
            ],
        },
    ];

    const data = [
        {
            id: 1,
            image: "/assets/icons/IndiaIcon/WhatWeOfferIcon1.png",
            title: "City-Focused Itinerary",
            desc: "Most programs are built entirely within Singapore due to its compact layout, allowing multiple attractions to be covered without long travel time."
        },
        {
            id: 2,
            image: "/assets/icons/IndiaIcon/WhatWeOfferIcon2.png",
            title: "Short Stay Travel Duration",
            desc: "Singapore is usually planned for 2–4 nights, which is enough to cover major attractions along with leisure time."
        },
        {
            id: 3,
            image: "/assets/icons/IndiaIcon/WhatWeOfferIcon3.png",
            title: "Clustered Attraction Visits",
            desc: "Key areas like Marina Bay Sands, Gardens by the Bay, and Sentosa are grouped together to reduce unnecessary movement across the city."
        },
        {
            id: 4,
            image: "/assets/icons/IndiaIcon/WhatWeOfferIcon4.png",
            title: "Sentosa Island Planning",
            desc: "Sentosa is typically planned as a dedicated half-day or full-day visit, with attractions like Universal Studios Singapore scheduled based on client interest."
        },
        {
            id: 5,
            image: "/assets/icons/IndiaIcon/WhatWeOfferIcon5.png",
            title: "Hotel Location Strategy",
            desc: "Hotels are selected in areas like Marina Bay, Orchard Road, or Clarke Quay, where location plays a key role in accessibility and convenience."
        },
        {
            id: 6,
            image: "/assets/icons/IndiaIcon/WhatWeOfferIcon6.png",
            title: "Public Transport & Easy Movement",
            desc: "Singapore’s transport system is efficient and reliable, allowing flexibility for both guided tours and independent exploration."
        },
        {
            id: 7,
            image: "/assets/icons/IndiaIcon/WhatWeOfferIcon7.png",
            title: "Free Time for Shopping & Dining",
            desc: "Itineraries include time for shopping and local dining, with areas like Orchard Road and Clarke Quay commonly featured."
        },
        {
            id: 8,
            image: "/assets/icons/IndiaIcon/WhatWeOfferIcon8.png",
            title: "Combination with Nearby Destinations",
            desc: "Singapore is often paired with destinations like Malaysia, Bali, or Thailand, making it ideal for multi-country travel plans."
        },
    ];

    return (
        <>
            <MainLayout bgImage={'url("https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/New-DMC/Figma%20Images/Destination/singapore.webp")'}
                text2={"Singapore"}
                button={true} />
            <IndiaSec1 IndiaSec1Data={SingaporeSec1Data} />
              <IndiaSec2 countryCode="SG" />
            <IndiaSec3 data={topcitydata} name={"Singapore"} />
            <IndiaSec4
                data={data}
                heading={"Singapore Experiences We Design "}
            />
            <Footer />

        </>
    )
};